import DadosLocais from '@/services/helper/storage'
import sessionService from '../helper/session.service';
const dadosLocais = DadosLocais.getInstance()

export default function contextHeader() {
  let grupo = "G";
  let CodigoPessoal = 0;
  let CodigoAluno = "0";

  if (sessionService.IsProfessor()) {
    grupo = "P";
    CodigoPessoal = sessionService.GetCodigoUsuarioProfessor();
  }
  else if (sessionService.IsResponsavel()) {
    grupo = "R";
    CodigoAluno = sessionService.GetEstudantesResponsavel().flatMap(x => x.valor).join(',').toString();
  }
  else if (sessionService.IsAluno()) {
    grupo = "A";
    CodigoAluno = sessionService.GetCodigoAluno().toString();
  }

  return { "UserGroup": grupo, "CodigoPessoal": CodigoPessoal, "CodigoAluno": CodigoAluno };
}